import { Country } from '@electricjs/arc';

import i18n from '@/i18n';

/** Returns the country name, already translated */
export function getCountryName(countryCode?: Country): string {
  if (!countryCode) {
    return '';
  }

  return i18n.t(`countries:${countryCode}.name`);
}
